import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Box, Card, CardContent, GridLegacy as Grid, Typography, useTheme } from '@mui/material';

import { Rate } from '~/services/AccommodationService';

interface RateInclusionsModalProps {
  inclusions: Rate['inclusions'];
  bonusInclusions: Rate['inclusions'];
  luxPlusInclusions?: Rate['inclusions'];
}

export default function RateInclusionsModal({
  inclusions,
  bonusInclusions,
  luxPlusInclusions,
}: RateInclusionsModalProps) {
  const theme = useTheme();

  if (
    (!inclusions || inclusions.length === 0) &&
    (!bonusInclusions || bonusInclusions.length === 0) &&
    (!luxPlusInclusions || luxPlusInclusions.length === 0)
  ) {
    return <Typography>No inclusions available for this rate.</Typography>;
  }

  return (
    <Box>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Included in this rate:
      </Typography>
      <Grid container spacing={2}>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          Inclusions
        </Typography>
        {inclusions.map((inclusion, index: number) => (
          <Grid item xs={12} key={index}>
            <Card variant="outlined" sx={{ mb: 1 }}>
              <CardContent sx={{ py: 1 }}>
                <Typography variant="body1">
                  <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                    <InfoIcon sx={{ mr: 1, color: theme.palette.success.main }} />
                    {inclusion.text}
                  </Box>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} sx={{ mt: 2, borderColor: theme.palette.info.main, borderStyle: 'solid', border: 1 }}>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          Bonus Inclusions
        </Typography>
        {bonusInclusions.map((inclusion, index: number) => (
          <Grid item xs={12} key={index}>
            <Card variant="outlined" sx={{ mb: 1 }}>
              <CardContent sx={{ py: 1 }}>
                <Typography variant="body1">
                  <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                    <InfoIcon sx={{ mr: 1, color: theme.palette.success.main }} />
                    {inclusion.text}
                  </Box>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {luxPlusInclusions && (
        <Grid
          container
          spacing={2}
          sx={{ mt: 2, borderColor: theme.palette.success.main, borderStyle: 'solid', border: 1 }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            LuxPlus Inclusions
          </Typography>
          {luxPlusInclusions.map((inclusion, index: number) => (
            <Grid item xs={12} key={index}>
              <Card variant="outlined" sx={{ mb: 1 }}>
                <CardContent sx={{ py: 1 }}>
                  <Typography variant="body1">
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
                      <InfoIcon sx={{ mr: 1, color: theme.palette.success.main }} />
                      {inclusion.text}
                    </Box>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
